import { render, staticRenderFns } from "./mediationCenter.vue?vue&type=template&id=547c5f40&scoped=true&"
import script from "./mediationCenter.vue?vue&type=script&lang=js&"
export * from "./mediationCenter.vue?vue&type=script&lang=js&"
import style0 from "./mediationCenter.vue?vue&type=style&index=0&id=547c5f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c5f40",
  null
  
)

export default component.exports